var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 87,
    viewBox: "0 0 115 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    clipPath: "url(#clip0_294_254)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3233 7.78691C85.5728 12.9563 97.4502 23.7606 100.404 42.5631C101.208 47.6775 100.085 43.8147 96.6865 41.2197C85.5908 32.7446 63.7745 35.7454 60.7467 55.1004C54.6553 89.3699 96.6371 95.3027 109.062 76.3764C111.953 71.9772 113.867 66.8422 114.556 61.2028C117.55 36.6761 105.235 14.8315 83.6007 4.57063C79.5982 2.6725 75.38 1.187 70.8407 0.0958099C68.5676 -0.371849 66.9168 0.888992 66.1553 3.02554C65.5107 4.84801 65.2906 6.85847 67.3233 7.78691ZM7.1774 7.78691C25.4269 12.9563 37.3065 23.7606 40.2579 42.5631C41.062 47.6775 39.9389 43.8147 36.5406 41.2197C25.4449 32.7446 3.62858 35.7454 0.603088 55.1004C-5.49281 89.3699 36.4912 95.3027 48.9166 76.3764C51.8073 71.9772 53.721 66.8422 54.4105 61.2028C57.4045 36.6761 45.0892 14.8315 23.4548 4.57063C19.4523 2.6725 15.2364 1.187 10.6948 0.0958099C8.42174 -0.371849 6.77086 0.888992 6.00943 3.02554C5.36481 4.84801 5.14469 6.85847 7.1774 7.78691Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 87,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 87)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationMark);
export default __webpack_public_path__ + "static/media/quotation-mark.a8afc5876f5f20f3f62addbfbc378401.svg";
export { ForwardRef as ReactComponent };